<template>
  <div
    class="prolong-rule-item"
    :class="{'is-active': check}"
    @click="$emit('click', item)">
    <div
      class="prolong-rule-item__title">
      {{ item.name || $t('Common.NoData') }}
    </div>
    <div class="prolong-rule-item__description">
      <div v-if="item.startTimeNextDay || item.endTimeCurrentDay">
        {{ $t('Tenders.TenderOpeningHours') }} {{ item.startTimeNextDay }} - {{ item.endTimeCurrentDay }}
      </div>
      <div v-if="item.timeByEnd || item.duration">
        {{ item.event === 1 ? $t('Tenders.ByChangingBestPrice') : $t('Tenders.ByNewBid') }}
        {{ item.timeByEnd }} {{ $t('Tenders.ProlongTender') }} {{ item.duration }} {{ $t('Tenders.Min') }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProlongRulesItem',
  props: {
    item: {
      type: Object
    },
    check: {
      type: Boolean
    }
  },
}
</script>
<style scoped lang="scss">
.prolong-rule-item {
  white-space: normal;
  cursor: pointer;
  position: relative;
  transition: all 0.25s;
  padding: 8px 14px;
  /*&:after {
    content: '';
    width: 17px;
    height: 17px;
    border: 1px solid var(--text-color);
    border-radius: 100%;
    position: absolute;
    top: 10px;
    left: 10px;
  }*/
  &.is-active {
    background-color: var(--color-main-green);
  }
  &:hover,
  &:focus {
    background-color: rgba(var(--color-main-green-rgba), 0.4);
  }
  &:hover,
  &:focus {
    opacity: 0.8;
  }
  /*&.is-active:before {
    content: '';
    width: 9px;
    height: 9px;
    background: var(--text-color);
    display: block;
    border-radius: 100%;
    position: absolute;
    top: 14px;
    left: 14px;
  }*/
  &__title {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.01em;
    margin-bottom: 8px;
  }
}
</style>
